import { Component } from '@angular/core';

import {AlertController, App, LoadingController, NavController, ToastController} from 'ionic-angular';
import { ModalController, ViewController,NavParams } from 'ionic-angular';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import {UiData} from "../../../providers/ui-data";
import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';

import { LocationSelectForm } from '../../utils/location-select/location-select';
import {Geolocation} from "@ionic-native/geolocation";
import {HomePage} from "../../home/home";

declare var google: any;

@Component({
    selector: 'page-address',
    templateUrl: 'address.html'
})
export class AddressPage {
    username: string;
    countryList: any;
    addressRef: any;
    addressData: any;
    addressForm : FormGroup;
    submitAttempt: boolean =false;

    inited: any = false;
    loading: any = false;
    currently_loading: any = false;

    zipcodeCompletor:any;
    modified: boolean = true;

    constructor(
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public afDatabase: AngularFireDatabase,
        private formBuilder: FormBuilder,
        public modalCtrl: ModalController,
        private geolocation: Geolocation,
        public loadingCtrl: LoadingController,
        public toastCtrl: ToastController,
        public app: App
    ) {
        //userData.setToken('nova4');
        this.addressForm = this.formBuilder.group({
            adr1: ['', [Validators.required,Validators.minLength(5)]],
            cp: ['', [Validators.required,Validators.pattern(this.uiData.getZipcodePattern()),Validators.minLength(4)]],
            ville: ['', [Validators.required,Validators.minLength(2)]],
            pays: [null, Validators.required],
        });

        //console.log(uiData.countryList());
        this.zipcodeCompletor=this.uiData.zipcodeCompletor;
    }
    back(event)
    {
        try{
            this.app.getRootNav().setRoot(HomePage);
            this.app.getRootNav().popToRoot();
        }catch(e){}
    }
    ngAfterViewInit() {
        this.addressData = {
            adr1 : '',
            adr2 : '',
            cp : '',
            ville : '',
            pays : 'FR',
        }
        ;
        this.countryList = this.uiData.countryList();

        var that = this;
        that.userData.userSession().subscribe(user => {
            that.userData.load().subscribe(data => {
                if(!data.address || !data.address.adr1)
                {
                    that.userData.set('address',that.addressData);
                }
                that.addressData = that.userData.get('address');
            });
        });
    }
    saveAddress() {
        this.submitAttempt=true;
        var that = this;

        if(this.addressForm.valid)
        {
            let prompt = this.alertCtrl.create({
                title: 'Confirmation des informations',
                message: that.uiData.getDataValidationWarning(),
                buttons: [
                    {
                        text: 'Oui',
                        handler: data => {
                            that.userData.set('address',that.addressData);
                            //that.app.getRootNav().setRoot('HomePage');
                            that.toastSuccess("Votre adresse a été enregistrée.");
                        }
                    },
                    {
                        text: 'Annuler',
                        handler: data => {

                        }
                    }
                ]
            });
            prompt.present();
        }
        else
        {
            //console.log(this.addressForm.value);
        }

    }
    toastSuccess(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 2000,
            position: 'bottom',
            closeButtonText:'Ok'
        });
        toast.present();
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading){
            this.currently_loading = false;
            this.loading.dismiss();
        }
    }
    geoLocate()
    {
        var that = this;
        this.setLoading(true,'Géolocalisation en cours ...');
        this.geolocation.getCurrentPosition().then((resp) => {
            var geocoder = new google.maps.Geocoder;
            var latlng = {lat: resp.coords.latitude, lng: resp.coords.longitude};
            var that = this;
            geocoder.geocode({'location': latlng}, function(results, status) {

                if (status === 'OK') {
                    if (results[0]) {
                        for(let i=0;i<results[0].address_components.length;i++)
                        {
                            let component = results[0].address_components[i];
                            if(component.types.includes("route"))
                            {
                                that.addressData.adr1 = component.long_name;
                            }
                            if(component.types.includes("locality"))
                            {
                                that.addressData.ville = component.long_name;
                            }
                            if(component.types.includes("postal_code"))
                            {
                                that.addressData.cp = component.long_name;
                            }
                            if(component.types.includes("country"))
                            {
                                that.addressData.pays = component.short_name;
                            }
                        }
                    } else {
                    }
                } else {
                }
                that.setLoading(false);
            });
        }).catch((error) => {
            const toast = this.toastCtrl.create({
                message: 'La géolocalisation a échoué. ' +
                'Il est possible que vous ayez refusé d\'être géolocalisé ou que les paramètres de votre appareil ne le permette pas.' +
                'N\'hésitez pas à choisir le mode de recherche par adresse.',
                showCloseButton: true,
                cssClass: 'danger',
                closeButtonText: 'Ok',
                dismissOnPageChange: true,
                duration:10000
            });
            toast.present();
            //this.searchFilters.location.mode = 'address';
            this.setLoading(false);
        });
    }
    swipe(event)
    {
        if(event.direction === 2) {
            this.nav.parent.select(2);
        }
        if(event.direction === 4) {
            this.nav.parent.select(0);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/account/address/address.ts